import { StyleSheet } from 'react-native'
import theme from '../../../theme'

const styles = StyleSheet.create({
    container: {
        marginTop: 5,
        marginHorizontal: 3,
    },
    bookmark: {
        width: 25,
        height: 25,
        marginTop: 1,
        marginLeft: 1,
        marginRight: -2,
    },
})

export default styles
